import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "p-6 text-center"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900 mb-2"
};
const _hoisted_3 = {
  class: "text-sm text-slate-500 mb-6"
};
const _hoisted_4 = {
  class: "flex items-center justify-center gap-3"
};
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'DeleteConfirmModal',
  props: {
    title: {
      type: String,
      default: '确定要删除吗？'
    },
    message: {
      type: String,
      default: '删除后无法恢复，请确认是否删除。'
    }
  },
  emits: ['close', 'confirm'],
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(AppModal, {
        visible: true,
        size: "sm",
        "panel-class": "mx-4",
        onClose: _cache[2] || (_cache[2] = $event => _ctx.$emit('close'))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "w-12 h-12 mx-auto mb-4 text-red-500"
        }, [_createElementVNode("svg", {
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        })])], -1)), _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(__props.message), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close')),
          class: "btn-secondary"
        }, "取消"), _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('confirm')),
          class: "btn-danger-secondary"
        }, "确定删除")])])]),
        _: 1
      });
    };
  }
};